import { outstandingAwpMembersDataset } from '@/lib/member-views/datasets/outstandingAwpMembers.dataset';
import type { OutstandingAwpMemberRow } from '@/lib/members/members.types';
import { MemberIdentityCell } from '../cells/MemberIdentityCell';
import { PhoneCell } from '../cells/PhoneCell';
import { PriorityTagsCell } from '../cells/PriorityTagsCell';
import { MemberViewShell, type MemberViewShellProps } from '../MemberViewShell';

const cellOverrides: MemberViewShellProps<OutstandingAwpMemberRow>['cellOverrides'] = {
  patient: (row) => <MemberIdentityCell firstName={row.firstName} lastName={row.lastName} mdvipId={row.mdvipId} />,
  phone: (row) => <PhoneCell mobile={row.mobilePhone} home={row.phone} />,
  priorityTags: (row) => <PriorityTagsCell tags={row.priorityTags} />,
};

/**
 * Outstanding AWP: the practice's members due an Annual Wellness Program visit.
 *
 * A function declaration for the same reason as `AllActiveMembersView`: the view registry and the
 * shell import each other, and a hoisted function survives that cycle where a `const` might not.
 */
export function OutstandingAwpMembersView() {
  return <MemberViewShell dataset={outstandingAwpMembersDataset} cellOverrides={cellOverrides} />;
}
